import { combineReducers } from "redux";

import months from "./months";
import years from "./years";

export default combineReducers({
  months,
  years,
});
